import { render } from "./TeamStatistics.vue?vue&type=template&id=a579689c&scoped=true&ts=true"
import script from "./TeamStatistics.vue?vue&type=script&lang=ts"
export * from "./TeamStatistics.vue?vue&type=script&lang=ts"

import "./TeamStatistics.vue?vue&type=style&index=0&id=a579689c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a579689c"]])

export default __exports__